// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u2HI","colBig":"styles_colBig__z_DIu","colSmall":"styles_colSmall__1OfHJ"};